/**
 * internal dependencies
 */
import { DASHBOARD_CONTAINER, PAGE_LOADER } from '../../../../types/types';
import { getParameters } from '../../../../helpers/helpers';

import { PIN_POOL_FORM, COMMON_FORM_ELEMENTS, DRIVER_ASK_FOR_ID } from "./utils/pin-pool-types";
import { displayInfo } from './utils/display-info';
import { pinPoolTable } from './utils/display-pinpool-table';

import GetCardGroupPinPool from '../../../../routes/get-pin-pool';
import { usePinPool } from './utils/use-pin-pool';
import { addPinPool } from './add/add-pin-pool';

import ExportCsv from '../csv/export-csv';

/**
 * Handles the Pin Pool functionality for the Individual Card Group.
 * 
 * @returns void
 */
const HandleDriverPinPool = async () => {
  const groupID = getParameters('cardGroupID');
  if (!groupID) return;

  try {
    const response = await GetCardGroupPinPool(groupID);
    const { pinPool: { hasPinPool, pins }, cardGroup } = response.body;
    const { ppActive } = PIN_POOL_FORM;
    const { ceExport, ceOptional } = COMMON_FORM_ELEMENTS;

    displayInfo(cardGroup);

    if (hasPinPool) {      
      ppActive.checked = true;
      usePinPool(ppActive, response, DRIVER_ASK_FOR_ID);
      pinPoolTable(pins, DRIVER_ASK_FOR_ID);
      ceExport.classList.remove('aafp_pin-disabled');
    }

    if ( !hasPinPool && pins.length > 0 ) {
      usePinPool(ppActive, response, DRIVER_ASK_FOR_ID);
      pinPoolTable(pins, DRIVER_ASK_FOR_ID);
      ceOptional.forEach(field => {
        field.classList.add('aafp_pin-disabled');
      });
    }

    addPinPool(response, DRIVER_ASK_FOR_ID);

    ppActive.addEventListener('click', () => usePinPool(ppActive, response, DRIVER_ASK_FOR_ID));

    ceExport.addEventListener('click', () => {
      ceExport.classList.add('aafp_button-loading');
      ExportCsv(response, 'pin_pool');
    });
  } catch (error) {
    console.error('Error fetching Pin Pool data:', error);
  } finally {
    PAGE_LOADER.loaderContainer.classList.add('aafp_no-show');
    DASHBOARD_CONTAINER.removeAttribute('style');
  }
};

export default HandleDriverPinPool;